<div class="flex flex-column gap-5 mb-8">
  <div class="px-8 py-3 bg-surface-opacity-5">
    <div
      class="flex flex-column gap-2 justify-content-center align-items-center">
      <div class="flex gap-5 align-items-center px-8">
        <app-logo hStyleClass="h-10rem w-14rem" [logoFileName]="config?.logo" />
        <p-divider layout="vertical" />
        <div class="flex flex-column gap-3">
          <h1 class="m-0">
            {{
              config.headline ||
                globalStore.activeCommune()?.title ||
                globalStore.activeCommune()?.name
            }}
          </h1>
          @if (config.startTeaser; as teaser) {
            <div
              [innerHTML]="teaser"
              [ngClass]="{
                'text-2xl': teaser.length < 100,
                'text-xl': teaser.length < 200,
                'text-l': teaser.length > 200,
              }"></div>
          }
        </div>
      </div>
    </div>

    <div class="absolute top-0 right-0 p-3">
      <p-button
        [text]="true"
        icon="fas fa-info"
        [rounded]="true"
        (click)="showInfo()"></p-button>
    </div>
  </div>
  <div
    class="flex gap-6 justify-content-center align-items-start align-content-evenly mx-6">
    <div class="flex flex-column justify-content-center gap-3 flex-wrap">
      <div
        class="p-card p-4 w-20rem flex flex-column bg-primary cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round-3xl"
        (click)="callSearch()">
        <header>
          <h3 class="mt-0 flex align-items-center gap-3 text-2xl">
            <i class="fas fa-search"></i>
            <span>Suche starten</span>
          </h3>
        </header>
        <div class="flex align-items-baseline gap-4">
          <i class="fas fa-arrow-right"></i>
          <div class="pb-3">Inhalte, Daten, Berichte finden und darstellen</div>
        </div>
      </div>
      <div
        class="p-card p-4 w-20rem flex flex-column bg-primary cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round-3xl"
        (click)="closeLandingPage()">
        <header>
          <h3 class="mt-0 flex align-items-center gap-3 text-2xl">
            <i class="fas fa-screwdriver-wrench"></i>
            <span>Erstellen</span>
          </h3>
        </header>
        <div class="flex align-items-baseline gap-4">
          <i class="fas fa-arrow-right"></i>
          <div class="pb-3">Eigene Ansichten erstellen / Daten explorieren</div>
        </div>
      </div>
    </div>
    @if (globalStore.communeConfiguration(); as config) {
      <div class="flex gap-3 flex-wrap">
        @if (checkDefaultBookmark()) {
          <div
            class="p-card p-4 w-20rem flex flex-column bg-primary cursor-pointer hover:shadow-8 transition-all transition-duration-300 border-round-3xl"
            (click)="callStartPage()">
            <header>
              <h3 class="mt-0 flex align-items-center gap-3 text-2xl">
                <i class="fas fa-house-laptop"></i>
                <span>Start</span>
              </h3>
            </header>
            <div class="flex align-items-baseline gap-4">
              <i class="fas fa-arrow-right"></i>
              <div class="pb-3">Startansicht laden</div>
            </div>
          </div>
        }
        @if (config.landingPageItems?.length) {
          @for (item of config.landingPageItems; track $index) {
            @if (enhancedLandingPageItem(item); as landingPageItem) {
              <div class="p-card p-3 w-20rem flex flex-column border-round-xl">
                <header>
                  <h3 class="mt-0 flex align-items-center gap-3">
                    <i [class]="landingPageItem.icon"></i>
                    <span>{{ landingPageItem.name }}</span>
                  </h3>
                </header>

                @if (landingPageItem.text) {
                  <div class="pb-3" [innerHtml]="landingPageItem.text"></div>
                }
                <footer class="mt-auto">
                  <p-button
                    [rounded]="true"
                    [label]="getLabelByType(item.type)"
                    icon="fas fa-arrow-right"
                    iconPos="right"
                    (click)="landingPageItemCTA(item)"></p-button>
                </footer>
              </div>
            }
          }
        }
      </div>
    }
  </div>
</div>

<footer class="p-2 fixed bottom-0 w-full bg-surface-opacity-5 z-1">
  <nav class="flex gap-3 justify-content-between">
    <a
      pButton
      class="no-underline text-color-secondary"
      severity="secondary"
      icon="fas fa-globe"
      size="small"
      label="Bertelsmann Stiftung"
      [text]="true"
      [rounded]="true"
      target="_blank"
      href="https://www.bertelsmann-stiftung.de/"></a>
    <a
      class="no-underline text-color-secondary"
      severity="secondary"
      pButton
      icon="fas fa-legal"
      size="small"
      label="Impressum"
      [text]="true"
      [rounded]="true"
      target="_blank"
      href="https://www.keck-atlas.de/system/impressum"></a>
    <a
      class="no-underline text-color-secondary"
      severity="secondary"
      pButton
      icon="fas fa-balance-scale"
      size="small"
      label="Datenschutz"
      [text]="true"
      [rounded]="true"
      target="_blank"
      href="https://www.keck-atlas.de/system/datenschutz"></a>
  </nav>
</footer>

<p-dialog [modal]="true" [(visible)]="infoVisible" [style]="{ width: '60rem' }">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0"
      icon="fas fa-info-circle"
      [text]="'Info'"></app-header>
  </ng-template>
  <p>Liebe Nutzer:innen,</p>
  <p>
    herzlich willkommen im Kommunal-Atlas – dem Online-Tool für die anschauliche
    und individuelle Auswertung kommunaler Daten. Mit dem Kommunal-Atlas können
    Sie Daten er Stadt, Gemeinde oder des Landkreises einfach und interaktiv
    erkunden. Ob kleinräumige Vergleiche, zeitliche Entwicklungen oder
    unterschiedliche Darstellungsformen – der Atlas hilft dabei, Disparitäten,
    Trends und Zusammenhänge schnell zu erkennen und gezielt zu handeln.
  </p>

  <app-header
    styleClass="mt-5"
    icon="fas fa-search"
    text="„Suche“"></app-header>
  <p>
    Hier können Sie nach bestimmten Indikatoren, Räumen oder Ortsteilen, Themen,
    Berichten oder Ansichten suchen. Geben Sie einfach ein Stichwort ein – der
    Kommunal-Atlas erstellt mit einem Klick automatisch eine Ansicht bestehend
    aus verschiedenen Darstellungen.
    <br />
    Probieren Sie es aus: Wählen Sie einzelne Indikatoren per Klick auf das
    Augen-Icon oder kombinieren Sie mehrere über das Plus-Icon – so entsteht
    schnell eine interaktive Übersicht. Indikatoren lassen sich zusätzlich
    filtern und über Schlagworte eingrenzen.
  </p>

  <app-header
    styleClass="mt-5"
    icon="fas fa-screwdriver-wrench"
    text="„Erstellen“"></app-header>
  <p>
    Möchten Sie Ihre eigene Ansicht gestalten? Unter „Erstellen“ können Sie sich
    Ihre Datenansicht individuell zusammenstellen – z. B. mit Karten,
    Kreisdiagrammen, Liniendiagrammen oder Tabellen. Alles lässt sich flexibel
    anpassen.
  </p>

  <app-header
    styleClass="mt-5"
    icon=""
    text="Navigation über weiße Buttons"></app-header>
  <p>
    Die weißen Buttons auf der Seite führen Sie direkt zu den verschiedenen
    Themen, Berichten und Ansichten, welche von der Kommune für Sie
    zusammengestellt wurden. So finden Sie schnell, was Sie interessiert.
    <br />
    Schauen Sie sich in Ruhe um, probieren Sie die Funktionen aus und entdecken
    Sie, was in den kommunalen Daten steckt.
  </p>
  <p>Viel Spaß beim Erkunden!</p>
</p-dialog>
